import React, { useState, useEffect } from 'react'
import scrollToComponent from 'react-scroll-to-component'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import './styles.less'
import ProjectDataTable from '../../../widgets/dataTable/ProjectDataTable'
import SearchProjectInformation from '../../../widgets/search/SearchProjectInformation'
import { cloneDeep } from 'lodash-es'
import ApproveProposalMultiWidget from '../../../widgets/approveProposalWidget/ApproveProposalMultiWidget'
import {
  addToWaittingNotApproveList,
  deleteWaitingNotApporveProject,
  getWaitingNotApporveSchema,
  searchWaitApporve,
} from '../../../redux/actions/multiApprove'
import ConfirmWidget from '../../../widgets/confirm/ConfirmWidget'
import notification from '../../../utils/notification'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'

export default function NotApproveProjectMulti() {
  const [searchResultLoading, setSearchResultLoading] = useState(false)
  const [error, setError] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [projectSearchResult, setProjectSearchResult] = useState()
  const [schema, setSchema] = useState()
  const [projectIdList, setProjectIdList] = useState()
  const [selectDeleteProject, setSelectDeleteProject] = useState()

  const [isShowConfimModal, setIsShowConfimModal] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [approveType, setApproveType] = useState()

  useEffect(() => {
    // let apt = location.search.substring(1)
    let apt = sessionStorage.getItem('param')?.substring(1)
    console.log('apt : ', apt)
    setApproveType(apt)
    handleGetSchema(apt)
  }, [])

  const handleGetSchema = async (apt) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getWaitingNotApporveSchema(apt)
      setSchema(response)
      setProjectIdList(response?.forms?.waitingApprove?.values?.map((item) => item.id) || [])
    } catch (e) {
      console.log('e', e)
      setError({})
    }

    try {
      const request = {
        projectCode: '',
        projectName: '',
        projectType: '',
        projectRound: '',
        projectBudget: '',
        department: '',
      }

      const response = await searchWaitApporve(request, apt, 5, 1)

      setProjectSearchResult(response)
    } catch (e) {}

    doneLoading()
    setIsLoading(false)
  }

  const handleSearch = async (request, approveType, pagesize, pagenumber) => {
    setSearchResultLoading(true)
    startLoading()
    try {
      let _schema = cloneDeep(schema)
      const response = await searchWaitApporve(request, approveType, pagesize, pagenumber)

      _schema.forms.projectSearchPanel.projectCode.value = request.projectCode
      _schema.forms.projectSearchPanel.projectName.value = request.projectName
      _schema.forms.projectSearchPanel.projectType.value = request.projectType
      _schema.forms.projectSearchPanel.projectBudget.value = request.projectBudget
      _schema.forms.projectSearchPanel.department.value = request.department

      setProjectSearchResult(response)
      setSchema(_schema)
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setSearchResultLoading(false)
  }

  const handleAdd = async (request) => {
    startLoading()
    try {
      await addToWaittingNotApproveList(request, approveType)
      reLoadData(true)
    } catch (e) {
      showSaveError(e?.errors?.message[0] || 'เกิดข้อผิดพลาดเพิ่มไม่สำเร็จ กรุณาลองใหม่อีกครั้ง')
    }
    doneLoading()
  }

  const handleRemoveSubmit = async (id) => {
    startLoading()
    try {
      const request = {
        projectVersionId: [id],
      }
      console.log('handleRemoveSubmit request', request)
      await deleteWaitingNotApporveProject(request, approveType)
      reLoadData(false)
    } catch (e) {
      console.log('e', e)
      showSaveError('เกิดข้อผิดพลาดลบไม่สำเร็จ กรุณาลองใหม่อีกครั้ง')
    }
    doneLoading()
  }

  const reLoadData = async (isAdd) => {
    try {
      const response = await getWaitingNotApporveSchema(approveType)
      setSchema(response)
      setProjectIdList(response?.forms?.waitingApprove?.values?.map((item) => item.id) || [])
      isAdd && setProjectSearchResult('')
    } catch (e) {
      // console.log('e', e)
      // setError({})
    }
  }

  const onReload = (pagesize, pagenumber) => {
    const request = {
      projectcode: schema.forms.projectSearchPanel.projectCode.value,
      projectName: schema.forms.projectSearchPanel.projectName.value,
      projectType: schema.forms.projectSearchPanel.projectType.value,
      projectBudget: schema.forms.projectSearchPanel.projectBudget.value,
      department: schema.forms.projectSearchPanel.department.value,
    }

    handleSearch(request, approveType, pagesize, pagenumber)
  }

  const onSearch = (data) => {
    // console.log('onSearch : ', data)

    const request = {
      projectCode: data.projectCode,
      projectName: data.projectName,
      projectType: data.projectType,
      projectBudget: data.projectBudget,
      department: data.department,
    }

    handleSearch(request, approveType, 5, 1)
  }

  const onClean = () => {
    let _schema = cloneDeep(schema)

    _schema.forms.projectSearchPanel.projectCode.value = ''
    _schema.forms.projectSearchPanel.projectName.value = ''
    _schema.forms.projectSearchPanel.projectType.value = ''
    _schema.forms.projectSearchPanel.projectBudget.value = ''
    _schema.forms.projectSearchPanel.department.value = ''

    setProjectSearchResult('')
    setSchema(_schema)
  }

  const handleSelect = (selectList) => {
    let selectProjectIds = []
    let waitingApprove = schema.forms.waitingApprove.values

    for (let index = 0; index < selectList.length; index++) {
      const element = selectList[index]
      let isDuplicate = waitingApprove.some((e) => e.id === element.id)

      if (!isDuplicate) {
        selectProjectIds.push(element.id)
      }
    }

    const request = {
      projectVersionId: selectProjectIds,
    }
    //call add project api
    handleAdd(request)
  }

  const onMultiComplete = () => {
    scrollToComponent(dataTableSection, { offset: 0, align: 'top', duration: 500 })
    handleReload(5, 1)
  }

  const onRemove = (obj) => {
    setSelectDeleteProject(obj)
    setIsShowConfimModal(true)
  }

  const showSaveError = (text) => {
    notification.open('error', {
      title: text,
      duration: 10000,
    })
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isMultiApprove>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isMultiApprove>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

      {schema?.forms?.projectSearchPanel && (
        <>
          <SearchProjectInformation
            schema={schema.forms.projectSearchPanel}
            onSearch={onSearch}
            onClean={onClean}
          />
        </>
      )}

      {projectSearchResult && (
        <>
          <ProjectDataTable
            schema={projectSearchResult}
            multi={{
              enable: true,
              buttonText: projectSearchResult.mutiButtonText || `เพิ่มไปยังพิจารณาไม่อนุมัติ`,
              icon: 'plus',
            }}
            onMultiSubmit={handleSelect}
            onReload={onReload}
            pagination={true}
            loading={searchResultLoading}
          />
        </>
      )}

      {schema?.forms?.waitingApprove && projectIdList?.length > 0 && (
        <>
          <ProjectDataTable
            schema={schema.forms.waitingApprove}
            single={{
              enable: true,
              buttonText: schema?.forms?.waitingApprove?.buttonText,
              icon: 'trash-o',
            }}
            onSingleSubmit={onRemove}
            pagination={true}
          />
        </>
      )}

      {schema?.forms?.approveProposal &&
        schema?.forms?.waitingApprove &&
        projectIdList?.length > 0 && (
          <div style={{ marginTop: 15 }}>
            <ApproveProposalMultiWidget
              projectVersionIdList={projectIdList}
              onComplete={onMultiComplete}
              schema={schema.forms.approveProposal}
              buttonWidth={220}
              approveStatus={3}
              approveType={approveType}
            />
          </div>
        )}

      <br />
      <ConfirmWidget
        title={`ยืนยันการลบ`}
        show={isShowConfimModal}
        detail={
          <p>
            {' '}
            ยืนยันการลบ <b>{selectDeleteProject?.projectName || ''}</b>{' '}
            ออกจากรายการพิจารณาอนุมัติหลายโครงการ
          </p>
        }
        onCancle={() => {
          setIsShowConfimModal(false)
          setSelectDeleteProject('')
        }}
        onConfirm={() => {
          setIsShowConfimModal(false)
          handleRemoveSubmit(selectDeleteProject?.id)
        }}
      />
    </SidebarProposal>
  )
}
